export default __webpack_public_path__ + "static/media/V220_CoC.2c6c3964.pdf";